module.exports = __webpack_public_path__ + "static/media/content.f006ca3e.png";